<template>
  <div class="wave-bg">
    <div class="wave-pattern">
      <inline-svg :src="$assets.svg['wave']" />
    </div>
  </div>
</template>

<style scoped>
.wave-bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, #75c7ab, #60c7ce, #4e99d0);
}

.wave-pattern {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-55%, -50%);
  width: 200%;
}

.wave-pattern svg {
  width: 100%;
  height: 100%;
}

/** Mobile: Landscape */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .wave-pattern {
    transform: translate(-50%, -50%);
    width: 100%;
  }
}

/** Larger Devices: Narrow */
@media only screen and (max-aspect-ratio: 1033/719) and (min-width: 601px) {
  .wave-pattern {
    transform: translate(-50%, -50%);
    width: 160%;
    height: 100%;
  }
}

/** Larger Devices: Wide */
@media only screen and (min-aspect-ratio: 1033/719) and (min-height: 601px) {
  .wave-pattern {
    transform: translate(-50%, -50%);
    width: 100%;
  }
}
</style>
